<template>
  <div class="presupuesto-interno-renglones alternativas">
    <!-- <b-card header="Alternativas"> -->
    <b-card>
      <template slot="header">
        Alternativas
        <i v-if="!confirmado"
            class="fa fa-plus add-alternativa"
            @click.prevent="addAlternativa">
          <span>Agregar Alternativa</span>
        </i>

        <b-btn class="btn-collapse-card" 
            variant="primary" 
            size="sm"
            @click.prevent="closeAlternativas">
          <i class="fa fa-remove"></i>
        </b-btn>
      </template>      
      <b-table
          :key="key"
          small 
          responsive="sm"
          :busy="tableBusy"
          :class="{ 
            'registro-ordenes': true, 
            'alternativas': true, 
            'cotizacion-interna': tieneRecargoServicioPropio,
            'cotizacion-final': consultarCotizacionFinal
          }"
          :items="alternativasDatos" 
          :fields="renglonesFields">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>
        <template v-slot:cell(tieneImagenes)="data">
          <template v-if="data.item.tieneImagenes">
            <i class="fa fa-image"></i>
          </template>
        </template>
        <template v-slot:cell(rubroTrabajo)="data">
          {{ data.item.rubroTrabajo }}
        </template>
        <template v-slot:cell(costoInterno)="data">
          {{ data.item.costoInterno | moneda(data.item.moneda) }}
        </template>
        <template v-slot:cell(pjeRentabilidad)="data">
          <template v-if="confirmado">
            {{ data.item.pjeRentabilidad | porcentaje }}
          </template>
          <template v-if="!confirmado">
            <template v-if="data.item.costoInterno == 0">
              {{ '--.--%' }}
            </template>
            <input
              type="number" 
              step="0.01"
              v-model="data.item.pjeRentabilidad"
              v-if="data.item.costoInterno != 0"
              @focus="$event.target.select()"
              @keyup.enter.prevent="actualizarPjeRentabilidadRenglon(data.item)"
              @change="actualizarPjeRentabilidadRenglon(data.item)"/>
          </template>
        </template>
        <template v-slot:cell(pjeImpuestos)="data">
          {{ data.item.pjeImpuestos | porcentaje }}
        </template>
        <template v-slot:cell(cotizacionInterna)="data">
          <template v-if="confirmado">
            {{ data.item.cotizacionInterna | moneda(data.item.moneda) }}
          </template>
          <template v-if="!confirmado">
            <template v-if="data.item.cotizacionInternaDisabled">
              {{ data.item.cotizacionInterna | moneda(data.item.moneda) }}
            </template>
            <template v-if="!data.item.cotizacionInternaDisabled">
              <app-formatted-cotizacion
                :id="data.item.id"
                :importe="data.item.cotizacionInterna"
                :moneda="data.item.moneda"
                @actualizarImporte="actualizarCotizacionInternaRenglon">
              </app-formatted-cotizacion>
              <!-- <input 
                  type="number"
                  v-model="data.item.cotizacionInterna"
                  @focus="$event.target.select()"
                  @keyup.enter.prevent="actualizarCotizacionInternaRenglon(data.item)"
                  @change="actualizarCotizacionInternaRenglon(data.item)"/> -->
            </template>
          </template>
        </template>
        <template v-slot:cell(cotizacionFinal)="data">
          {{ data.item.cotizacionFinal | moneda(data.item.moneda) }}
        </template>
        <template v-slot:cell(cotizacion)="data">
          <template v-if="confirmado">
            {{ data.item.cotizacion | moneda(data.item.moneda) }}
          </template>
          <template v-if="!confirmado">
            <template v-if="data.item.cotizacionDisabled">
              {{ data.item.cotizacion | moneda(data.item.moneda) }}
            </template>
            <template v-if="!data.item.cotizacionDisabled">
              <app-formatted-cotizacion
                :id="data.item.id"
                :importe="data.item.cotizacion"
                :moneda="data.item.moneda"
                @actualizarImporte="actualizarCotizacionRenglon">
              </app-formatted-cotizacion>
              <!-- <input 
                  type="number"
                  v-model="data.item.cotizacion"
                  @focus="$event.target.select()"
                  @keyup.enter.prevent="actualizarCotizacionRenglon(data.item)"
                  @change="actualizarCotizacionRenglon(data.item)"/> -->
            </template>
          </template>
        </template>
        <template v-slot:cell(seleccionada)="data">
          <span v-if="data.item.seleccionada" class="col-alternativas">*</span>
        </template>
        <template v-slot:cell(opciones)="data">
          <b-dropdown
              v-if="!confirmado"
              variant="link" toggle-class="text-decoration-none" no-caret>
            <template slot="button-content">
              <i class="fa fa-ellipsis-v"></i>
            </template>
            <b-dropdown-item
                :disabled="data.item.seleccionada" 
                @click.stop="seleccionarAlternativa(data.item)">
              <i class="fa fa-check"></i>Seleccionar Alternativa</b-dropdown-item>
            <b-dropdown-item 
                @click.stop="editarAlternativa(data.item)">
              <i class="fa fa-edit"></i>Editar Datos de la Alternativa</b-dropdown-item>
            <!-- <b-dropdown-item
                v-if="accesoImagenes"
                :disabled="data.item.ordenTrabajo.ordenTrabajoId == 0" 
                @click.stop="consultarImagenes(data.item)">
              <i class="fa fa-image"></i>Consultar Imágenes de la Orden</b-dropdown-item> -->
            <b-dropdown-item 
                :disabled="data.item.certificado || (data.item.seleccionada && !borrarSeleccionadaHabilitado)"
                @click.stop="borrarAlternativa(data.item)">
              <i class="fa fa-remove"></i>Borrar Alternativa</b-dropdown-item>
          </b-dropdown>
        </template>

        <template v-slot:cell(detailShowing)="row">
          <b-btn class="detailShowing" 
              size="sm" 
              v-if= 'row.item.ordenTrabajoAlternativa.descripcion != ""'
              @click.stop="row.item._showDetails = !row.item._showDetails">
            {{ row.item._showDetails ? '-' : '+' }}
          </b-btn>            
        </template>

        <!--<template v-slot:row-details="row" v-if="row.item.showDescripcion">-->
        <template v-slot:row-details="row">
          <b-row v-if='row.item.ordenTrabajoAlternativa.descripcion != ""'>
            <b-col xl="12">
              <p class="orden-descripcion"> {{ row.item.ordenTrabajoAlternativa.descripcion }} </p>
            </b-col>
          </b-row>
        </template>
      </b-table>

      <small><span class="col-alternativas">*</span> Alternativa seleccionada </small>  
    </b-card>
    
    <!-- <b-modal ref="ordenTrabajoImagenesModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalOrdenTrabajo">
      <app-orden-trabajo-imagenes
        :ordenTrabajoId="ordenTrabajoId"
        @close="closeImagenes">
      </app-orden-trabajo-imagenes>  
    </b-modal> -->

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
// import OrdenTrabajoImagenes from '../ordenestrabajos/Imagenes';
import FormattedCotizacion from '../shared/formattedCurrency.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import moment from 'moment';

import { mapState } from 'vuex';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestointerno/getField',
  mutationType: 'presupuestointerno/updateField',
});

export default {
  name: 'PresupuestosInternosAlternativas',
  components: {
    // appOrdenTrabajoImagenes: OrdenTrabajoImagenes,
    appFormattedCotizacion: FormattedCotizacion,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  props: {
    accesoImagenes: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      ordenTrabajoAlternativaId: 0,

      labelCols: 2,
      tableBusy: false,
      key: 1000
    }
  },
  computed: {
    ...mapFields([
      'clienteId',
      'monedaId',
      'pjeRecargoServicioPropio',
      'confirmado',

      'ordenTrabajoAlternativas',
      'alternativasDatos'
    ]),
    monedaSimbolo() {
      if (this.monedaId) {
        if (this.monedaId == 102) {  
          return 'usd';
        }
      }
      return '$';
    },
    tieneRecargoServicioPropio() {
      return this.pjeRecargoServicioPropio != 0;
    },
    consultarCotizacionFinal() {
      if (this.clienteId) {
        if (this.clienteId == 58) {
          return true;
        }
      }
      return false;
    },
    renglonesFields() {
      let fields = [
        { 
            key: 'tieneImagenes',
            label: '',
            class: 'text-center'
        },
        {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
        },
        // {
        //   key: 'rubroTrabajo',
        //   label: 'Rubro',
        //   sortable: true
        // },
        {
          key: 'titulo',
          sortable: true
        },
        { 
          key: 'cantidad', 
          class: "text-right" },
        { 
          key: 'costoInterno', 
          label: 'Costo Interno',
          class: "text-right" 
        },
        { 
          key: 'pjeRentabilidad', 
          class: "text-right", 
          label: '% Rent.' 
        },
      ]

      if (this.pjeRecargoServicioPropio != 0) {
        fields.push({ 
            key: 'cotizacionInterna', 
            class: "text-right", 
            label: 'Cotización Interna'
          });
      }
      fields.push({ 
        key: 'cotizacion', 
        class: "text-right", 
        label: 'Cotización'
      });
      if ((/true/i).test(this.consultarCotizacionFinal)) {
        fields.push({ 
          key: 'cotizacionFinal', 
          class: "text-right", 
          label: 'Cotiz. Final'
        });
      }
      fields.push({
        key: 'seleccionada',
        label: '',
        class: 'text-center'
      });
      fields.push({ 
        key: 'opciones',
        label: '',
        class: 'text-center'
      });
      
      return fields;
    },
    borrarSeleccionadaHabilitado() {
      if (this.ordenTrabajoAlternativas) {
        if (this.ordenTrabajoAlternativas.alternativas) {
          return this.ordenTrabajoAlternativas.alternativas.length == 1;
        }
      }

      return false;
    }
  },  
  created() {
  },
  destroyed() {
  },
  methods: {
    refresh() {
      this.key++;
    },
    editarAlternativa(item) {
      if ((/true/i).test(!this.confirmado)) {
        this.$emit('editarAlternativa', item.ordenTrabajoAlternativa);
      }
    },
    borrarAlternativa(item) {
      if ((/true/i).test(!this.confirmado)) {
        this.showModalConfirm('¿Desea eliminar la alternativa seleccionada del presupuesto?', 
          this.borrar.bind(this, item.id), 'Borrar', null, 'Cancelar');
      }
    },
    borrar(ordenTrabajoAlternativaId) {
      if ((/true/i).test(!this.confirmado)) {
        this.showSpinner();
        this.$store.dispatch('presupuestointerno/deleteOrdenAlternativa', ordenTrabajoAlternativaId)
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    seleccionarAlternativa(item) {
      if ((/true/i).test(!this.confirmado)) {
        this.$emit('seleccionarAlternativa', item.ordenTrabajoAlternativa);
      }
    },
    actualizarPjeRentabilidadRenglon(item) {
      if ((/true/i).test(!this.confirmado)) {
        let params = {
          ordenTrabajoAlternativaId: item.id,
          pjeRentabilidad: item.pjeRentabilidad
        }

        this.tableBusy = true;
        this.$store.dispatch('presupuestointerno/updatePjeRentabilidadOrdenAlternativa', params)
          .catch(error => this.showErrorMsj(error))      
          .finally(() => this.tableBusy = false);
      }
    },    
    actualizarCotizacionRenglon(params) {
      if ((/true/i).test(!this.confirmado)) {
        params.ordenTrabajoAlternativaId = params.id;
        params.cotizacion = params.importe;

        this.tableBusy = true;
        this.$store.dispatch('presupuestointerno/updateCotizacionOrdenAlternativa', params)
          .catch(error => this.showErrorMsj(error))      
          .finally(() => this.tableBusy = false);
      }
    },   
    actualizarCotizacionInternaRenglon(params) {
      if ((/true/i).test(!this.confirmado)) {
        params.ordenTrabajoAlternativaId = params.id;
        params.cotizacion = params.importe;

        this.tableBusy = true;
        this.$store.dispatch('presupuestointerno/updateCotizacionInternaOrdenAlternativa', params)
          .catch(error => this.showErrorMsj(error))      
          .finally(() => this.tableBusy = false);
      }
    },
    consultarImagenes(item) {
    },
    closeImagenes(params) {
    },
    addAlternativa() {
      if ((/true/i).test(!this.confirmado)) {
        this.$emit('agregarOrdenAlternativa', this.ordenTrabajoAlternativas);
      }
    },
    closeAlternativas() {
      this.$emit('closeAlternativas');
    }
  },
  watch: {
  }    
}
</script>

<style>
  .presupuesto-interno-renglones.alternativas .card-header i.add-alternativa {
    position: relative;
    color: rgba(32, 168, 216, 0.5);
    cursor: pointer;
    margin-left: 12px;
    top: 2px; 
  }
  .presupuesto-interno-renglones.alternativas .card-header i.add-alternativa:hover {
    color: #20a8d8;
  }
  .presupuesto-interno-renglones.alternativas .card-header span {
    font-size: 11px;
    font-weight: 600;
    font-style: italic;
    top: -2px;
    position: relative;
    color: rgba(32, 168, 216, 0.5);
    margin-left: 5px;
  }
  .presupuesto-interno-renglones.alternativas .card-header i.add-alternativa:hover span{
    color: #20a8d8;
  }
</style>